import Paging from '@Components/MuiWrappers/Paging';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import BlogArticleCategories from '@Components/Blog/BlogArticleCategories';
import BlogArticleTags from '@Components/Blog/BlogArticleTags';
import BlogArticleArchiveMenu from '@Components/Blog/BlogArticleArchiveMenu';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import translator from '@Components/Utilities/Translator';

const BlogListView = (props) => {

    const pageChange = (page) => {
        window.location.href = props.Paging.PagedURLTemplate + '/' + props.Paging.PageTranslation + '/' + page;
    };

    const breadCrumbs = [
        { Label: translator.translate('sandhills.tradepubwebsite.mvc.home'), Url: props.BreadCrumbHomeRoute },
        { Label: props.BreadCrumbText, Url: "/blog/archive" },
    ];

    return (
        <div className='content-wrapper'>
            <div className='content-body'>
                <ComplexBreadcrumb BreadCrumbModels={breadCrumbs} />
                <div className='article-content-wrapper'>
                    <div className='content-wrapper ts-flexbox border-bottom'>
                        <h1 className='page-title'>{props.ArticleTitle}</h1>
                        <a id='blog-rss-link' href={props.RSSUrl} aria-label='RSS XML data'><i className='fas fa-rss right rss link-bl' aria-hidden='true' /></a>
                    </div>
                    <div className='blog-col-center'>
                        <div>
                            {props.ArticleList && props.ArticleList.length > 0 &&
                                props.ArticleList.map((article, index) =>
                                    <div key={index} itemScope itemType='https://schema.org/BlogPosting' className='blog-list-item'>
                                        <div className='column3 left blog-list-item-image-wrapper'>
                                            {article.Thumbnail > 0 &&
                                                <div className='blog-list-item-image'>
                                                    <a href={article.Url}>
                                                        <img itemProp='image' alt={article.PageHeader} src={article.ImageUrl} />
                                                    </a>
                                                </div>}
                                        </div>
                                        <div className={(article.Thumbnail > 0 ? 'column9' : 'column12') + ' left'}>
                                            <div className='blog-list-item-title'>
                                                <span itemProp='datePublished' content={article.DisplayLastUpdate ? article.UpdatedDateFormatted : article.PostedDateFormatted}></span>
                                                <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                                    <a itemProp='url' href={article.Url}><span itemProp='headline'>{article.PageHeader}</span></a>
                                                </ConditionalWrapper>
                                            </div>
                                            <div className='blog-list-item-date'>{article.DisplayLastUpdate ? article.UpdatedOnDateFormatted : article.PostedOnDateFormatted}</div>
                                            <div itemProp='description' className='blog-list-item-body'>
                                                {article.SummaryPlainText}
                                            </div>
                                            <div className='blog-list-item-read-more'>
                                                <a className='uppercase' href={article.Url}><TranslationText tKey='sandhills.tradepubwebsite.mvc.readthefullblogpost' /></a>
                                            </div>
                                            <div className='clear' />
                                        </div>
                                    </div>)}
                            <div className='row paging article-paging'>
                                {props.Paging.TotalPages > 1 &&
                                    <Paging
                                        currentPage={props.Paging.CurrentPage}
                                        totalPages={props.Paging.TotalPages}
                                        onChange={pageChange}
                                    />}
                            </div>
                        </div>
                    </div>
                    <div className='blog-col-right columns'>
                        <BlogArticleCategories Categories={props.Categories} UseSEOHTagReorganization={props.UseSEOHTagReorganization} />
                        {props.Tags && props.Tags.length > 0 && <BlogArticleTags Tags={props.Tags} />}
                        {props.DisplayArchiveList && <BlogArticleArchiveMenu ArchiveArticleList={props.ArchiveArticleList} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogListView;
global.BlogListView = BlogListView;